import React from 'react';
import PropTypes from 'prop-types';

// extends React.Component is required because of reference in parent
export default class FieldMultiselect_PopoverOption extends React.Component<any> {

    static propTypes = {
        option: PropTypes.object,

        isHighlighted: PropTypes.bool,
        isSelected: PropTypes.bool,

        onClick: PropTypes.func,
    }

    onClick = () => {
        this.props.onClick(this.props.option)
    }

    renderWithColor() {

        const option = this.props.option

        const classes = Classes('option', 'pill', {
            'highlighted': this.props.isHighlighted
        });

        const valueClasses = Classes('ui5-pillbox s26', 'w200', {
            ['gd-c-bgp-'+option.color]: !!option.color,
            ['gd-c-pale-border-'+option.color]: !!option.color,
        })

        return (
            <div className  = {classes}
                 onClick    = {this.onClick}
            >
                {!option.isAllValuesOption &&
                    <div className={Classes("ui5-cb s-16 m-r-10", this.props.className, {selected: this.props.isSelected})}/>}

                <div className={valueClasses}>{option.label}</div>
            </div>
        )
    }

    renderNoColor() {
        const classes = Classes('option', {
            'highlighted': this.props.isHighlighted
        });

        const valueClass = Classes('label', {
            bold: this.props.isSelected
        });

        return (
            <div className={classes} onClick={this.onClick}>
                {!this.props.option.isAllValuesOption &&
                    <div className={Classes("ui5-cb s-16 m-r-10", this.props.className, {selected: this.props.isSelected})}/>}

                {this.props.option.icon &&
                    <div className={Classes("ico", this.props.option.icon)}/>}

                <div className={valueClass}>{this.props.option.label}</div>
            </div>
        );
    }

    render() {

        if (!!this.props.option.color) {
            return this.renderWithColor()
        } else {
            return this.renderNoColor()
        }

        // const RenderComponent = !!this.props.option.color ? OptionPill : OptionText;
        // return <RenderComponent {...this.props} onClick={this.onClick}/>
    }
}